import { aiFirstCreationStreamingState } from '@databases/database-ai-first-creation-state';
import { useDatabaseStreamState } from '@databases/database-ai-first-creation-ui';
import { useSnapshot } from 'valtio';

import { useIsAiSummaryFieldEnabled } from './summary/use-is-ai-summary-field-enabled';

export interface UseIsAiFieldCellStreamingOptions {
  fieldId: string;
  entryId: string;
}

export const useIsAiFieldCellStreaming = ({
  fieldId,
  entryId
}: UseIsAiFieldCellStreamingOptions): boolean => {
  const isAiSummaryFieldEnabled = useIsAiSummaryFieldEnabled();
  const { activeStream } = useDatabaseStreamState();
  const { activeAiFieldCell } = useSnapshot(aiFirstCreationStreamingState);

  if (!isAiSummaryFieldEnabled || activeStream?.kind !== 'ai-field') {
    return false;
  }

  const { target } = activeStream;
  if (target.aiFieldType !== 'summary' || target.fieldId !== fieldId) {
    return false;
  }

  if (target.scope === 'entry' && target.entryId !== entryId) {
    return false;
  }

  return activeAiFieldCell?.fieldId === fieldId && activeAiFieldCell.entryId === entryId;
};
